import { html } from "lit-html";
import { classMap } from "lit-html/directives/class-map.js";
import { Base } from "@escapio/shared/components/dialogs/Base";
import connect from "@escapio/shared/data-store/connect";
import {
	ACTION_CHANGE_BOARD_FILTER,
	ACTION_RESET_PRICE_FILTER,
	ACTION_SET_PRICE_FILTER,
	ACTION_TOGGLE_CANCELATION_FILTER,
	store,
} from "./DataStore";
import { scrollToTop } from "../../dom/smoothScroll";
import { translate } from "@escapio/shared/l10n/translate";
import "./PriceFilterSection";
import "./BoardFilter";
import { track } from "../../tracker/EventTracker";
import { data } from "@escapio/shared/state/payload";

export class FilterDialog extends connect(Base, store) {
	constructor() {
		super();
		this.initialFilters = null;
		this.resetOnHide = true;
		this.node.classList.add("dialog--filter");
	}

	show() {
		this.initialFilters = {
			...store.getState().filters,
		};
		this.resetOnHide = true;
		super.show();
		track("Filter (Merkliste)", "Filter Layer geöffnet", data.trackingId);
	}

	hide() {
		if (this.resetOnHide) {
			store.dispatch(
				ACTION_TOGGLE_CANCELATION_FILTER,
				this.initialFilters.cancelation,
			);
			store.dispatch(ACTION_CHANGE_BOARD_FILTER, this.initialFilters.board);
			if (this.initialFilters.price === null) {
				store.dispatch(ACTION_RESET_PRICE_FILTER);
			} else {
				store.dispatch(ACTION_SET_PRICE_FILTER, this.initialFilters.price);
			}
		}
		super.hide();
		scrollToTop(document.getElementById("search-panel"));
	}

	getTemplateHeaderMiddle() {
		return html`<i class="fa fa-sliders"></i>`;
	}

	getTemplateContent() {
		return html`
			<esc-favorites-price-filter-section
				class="filter-box__section"
			></esc-favorites-price-filter-section>
			<esc-favorites-board-filter
				class="filter-box__section"
			></esc-favorites-board-filter>
		`;
	}

	getTemplateFooter() {
		const changed =
			this.initialFilters.cancelation != store.getState().filters.cancelation ||
			this.initialFilters.board != store.getState().filters.board ||
			this.initialFilters.price != store.getState().filters.price;
		return html`
			<div
				class="dialog__bottom-bar ${classMap({
					"dialog__bottom-bar--show": changed,
				})}"
			>
				<button
					class="action-button dialog__bottom-bar__button"
					?disabled=${!changed}
					@click=${this.applyAndClose}
				>
					${translate("basic_confirm")}
				</button>
			</div>
		`;
	}

	update() {
		this.render();
	}

	applyAndClose() {
		this.resetOnHide = false;
		this.hide();
	}
}
